// ========== کمک‌تابع‌های مشترک پرداخت‌های پیش‌فاکتور ==========

import { ltrValue } from "Common/constants/panelSpec";

/** شکل حداقلی یک پرداخت برای تابع‌های این ماژول. */
export interface PaymentTimestamps {
  accounting_confirmed?: boolean | null;
  /** زمان ثبت تأیید حسابداری؛ از نسخه ۳ بک‌اند. */
  accounting_confirmed_at_jalali?: string | null;
  accounting_confirmed_at?: string | null;
}

/**
 * تاریخ و زمان ثبت تأیید حسابداری.
 *
 * فقط مقدار اختصاصی سرور خوانده می‌شود. عمداً به created_at یا updated_at پرداخت
 * برگشت داده نمی‌شود، چون آن‌ها زمان آخرین تغییرِ رکوردند نه زمان تأیید و نمایش‌شان
 * به‌جای زمان تأیید گمراه‌کننده است.
 *
 * برای پرداخت‌هایی که پیش از نسخه ۳ تأیید شده‌اند این مقدار null است؛ در آن حالت
 * رشته‌ی خالی برمی‌گردد و سطر زمان اصلاً نمایش داده نمی‌شود.
 */
export const accountingConfirmedAt = (payment?: PaymentTimestamps | null): string => {
  if (!payment || !payment.accounting_confirmed) return "";
  const value = payment.accounting_confirmed_at_jalali || "";
  return String(value).trim();
};

/**
 * همان مقدار، آماده‌ی نمایش در متن راست‌به‌چپ.
 * بدون قفل جهت، الگوریتم دوجهته‌ی یونیکد «۱۴۰۵/۰۶/۲۴ ۱۱:۱۱:۱۱» را جابه‌جا می‌کند.
 */
export const accountingConfirmedAtLabel = (payment?: PaymentTimestamps | null): string => {
  const value = accountingConfirmedAt(payment);
  return value ? ltrValue(value) : "";
};

export default accountingConfirmedAt;
